/** Преобразует ARGB‑int → HEX (#RRGGBB) */
export const argbToHex = (argb: number): string =>
  "#" + (argb & 0x00FFFFFF).toString(16).padStart(6, "0");

/** Преобразует HEX (#RRGGBB) → ARGB‑int с полной непрозрачностью */
export const hexToArgb = (hex: string): number =>
  (0xFF << 24) | parseInt(hex.replace("#", ""), 16);

/** Осветлить ARGB‑цвет */
export function lightenColor(argb: number, factor = 0.7): string {
  const r = (argb >> 16) & 0xFF;
  const g = (argb >> 8) & 0xFF;
  const b = argb & 0xFF;
  const mix = (c: number) => Math.round(c + (255 - c) * factor);
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
}

/** Пастельные цвета в формате ARGB-int */
export const pastelColors: number[] = [
  0xFF212128, // мятный
  0xFF56779E, // синий
  0xFFA987AD, // сиреневый
  0xFF748E98, // голубой
  0xFFB57688, // персиковый
  0xFF46813B, // зелёный
];

/** Цвет по умолчанию */
export const DEFAULT_COLOR: number = pastelColors[3]; // голубой

/** Цвета задач (если используются отдельно) */
export const TASK_COLORS: string[] = [
  "#79A6DE", "#E0BBE4", "#FFD6E0", "#FFF1BA",
  "#AEC6CF", "#FDE2E4", "#DEBD94", "#EFABAA",
];
